import { fetchJson } from './request';

export function listGroups() {
  return fetchJson('/api/groups');
}

export function listGroupMembers(id) {
  return fetchJson(`/api/groups/${id}/members`);
}
